import XMLParser from "react-xml-parser";

export default class BaseRequest {
  static GetXMLRequest =   async (path, params = null) => {
    let url = null;
    if (params) {
      url = new URL(path);
      url.search = new URLSearchParams(params).toString();
    } else {
      url = path;
    }
    let response = await fetch(url, {
      method: "GET",
      "Content-Type": "text/xml; charset=utf-8",
      "Access-Control-Allow-Origin": "*",
      keepalive: true
    });
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(await response.text(), "text/xml");
    return xmlDoc;
  };

  static GetJsonFromXMLRequest = async (path, params = null) => {
    let url = null;
    if (params) {
      url = new URL(path);
      url.search = new URLSearchParams(params).toString();
    } else {
      url = path;
    }
    let response = await fetch(url, {
      method: "GET",
      "Content-Type": "text/xml; charset=utf-8",
      "Access-Control-Allow-Origin": "*",
      keepalive: true
    });
    let xmlText = await response.text();

    var xml = new XMLParser().parseFromString(xmlText);
    return xml;
  };
}
